<template>
  <div class="patents-copy-component">
    <div class="c-patents-copy">
      <section class="container">
        <div class="content">
          <br />
          <h3 class="is-size-4">CrowdFlik Patent Notice</h3>
          <p class="a-patents-paragraph">"Covered by the following patents</p>
          <ol class="1">
            <li class="a-patents-paragraph">
              United States Patent No. 9,129,640;
            </li>
            <li class="a-patents-paragraph">
              United States Patent No. 10,347,288;
            </li>
            <li class="a-patents-paragraph">
              China Patent No. ZL201380072869.0;
            </li>
            <li class="a-patents-paragraph">Japan Patent No. 6071090;</li>
            <li class="a-patents-paragraph">
              South Korea Patent No. 10-1680507; and
            </li>
            <li class="a-patents-paragraph">Canada Patent No. 2,898,441.”</li>
            <li class="a-patents-paragraph">Germany No. TBD</li>
            <li class="a-patents-paragraph">Great Britain No. TBD</li>
            <li class="a-patents-paragraph">Sweden No. TBD</li>
            <li class="a-patents-paragraph">Finland No. TBD</li>
            <li class="a-patents-paragraph">France No. TBD</li>
            <li class="a-patents-paragraph">Italy No. TBD</li>
          </ol>
          <br />
          <h3 class="is-size-4">CrowdFlik Patent Announcement</h3>
          <a
            href="https://www.prnewswire.com/news-releases/crowdflik-announces-launch-of-enterprise-solution-for-patented-mobile-video-collaboration-platform-300924799.html?tc=eml_cleartime"
            >Latest Patent Announcement (Sept 24, 2019)</a
          >
          <br />
          <a
            href="https://www.prnewswire.com/news-releases/crowdflik-announces-issuance-of-second-us-patent-for-mobile-video-synchronization--crowd-sourced-content-platform-300904962.html"
            >Previous Patent Announcement (Aug 21, 2019)</a
          >
        </div>
        <br />
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "PatentsCopyComponent"
};
</script>

<style scoped lang="scss"></style>
